/**
 * Blog-Favoriten Hook – localStorage-basiert, identisches Pattern wie Immobilien-Favoriten.
 * Speichert Blog-Slugs als Favoriten im localStorage unter "immozwerg-blog-favoriten".
 */
import { useState } from "react";

const STORAGE_KEY = "immozwerg-blog-favoriten";

export function useBlogFavoriten() {
  const [favoriten, setFavoriten] = useState<string[]>(() => {
    if (typeof window === "undefined") return [];
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
    } catch {
      return [];
    }
  });

  const toggle = (slug: string) => {
    setFavoriten((prev) => {
      const next = prev.includes(slug)
        ? prev.filter((s) => s !== slug)
        : [...prev, slug];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      return next;
    });
  };

  const istFavorit = (slug: string) => favoriten.includes(slug);

  return { favoriten, toggle, istFavorit };
}
